export enum InvalidAnswerReason {
  Outro = 0,
  PerguntaAberta = 1,
  PerguntaAmbigua = 2,
  ConteudoInadequado = 3,
  RespostaImprecisa = 4,
  LimitePerguntasAtingido = 5,
}
